import React from "react";

import { LogoBarBlock } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { getThemeClass } from "../ThemedModule";

import styles from "./LogoBar.module.scss";

export const LogoBar = ({ value }: { value: LogoBarBlock }) => {
    if (!value.logo) return null;

    return (
        <div
            className={concatClassNames([
                styles.root,
                getThemeClass(value.module_theme),
            ])}
        >
            <ImageChooserBlock
                value={value.logo}
                attrs={{ className: styles.logo }}
            />
        </div>
    );
};
